// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"4a5e2427","977":"3bdd41b0"}[chunkId] + ".chunk.js";
};